// extracted by mini-css-extract-plugin
export default {"cls1":"Xz4NkAC2ciKSwrJWVZsM","cls2":"BR6Ng27A2MwlryjUMQE2 Xz4NkAC2ciKSwrJWVZsM","isPhone":"T9WSIKCgUHycq_K55iIL"};